// plugins/google-analytics.ts
/* eslint-disable unicorn/prefer-global-this -- `window` tem a augmentation tipada
   (interface Window { gtag, dataLayer }); `globalThis` não a herda, então
   globalThis.gtag/dataLayer quebra o type-check (TS7017). Exceção escopada ao S7764. */
import type { App } from "vue";

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export default {
  install(app: App, options: { id: string }) {
    if (!options.id) {
      return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${options.id}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", options.id);
  },
};
